import { getCorporateModules } from './moduleRegistry';

const statusLabels = {
  active: 'Ativo',
  development: 'Em desenvolvimento',
} as const;

export const CorporateModules = () => {
  const modules = getCorporateModules();

  return (
    <section
      className="arx-corporate-modules"
      aria-labelledby="arx-corporate-modules-title"
      data-aranox-component="corporate-modules"
    >
      <div className="arx-executive-section-heading">
        <div>
          <span>PORTAL CORPORATIVO</span>
          <h2 id="arx-corporate-modules-title">Módulos corporativos</h2>
        </div>
        <p>
          Estrutura central de acesso aos domínios funcionais da Plataforma
          Digital ARANOX.
        </p>
      </div>

      <div className="arx-corporate-modules__grid">
        {modules.map(module => (
          <a
            href={module.route}
            className="arx-corporate-module-card"
            data-module-id={module.id}
            key={module.id}
          >
            <div className="arx-corporate-module-card__header">
              <span
                className="arx-corporate-module-card__icon"
                aria-hidden="true"
              >
                {module.icon}
              </span>
              <span
                className={`arx-corporate-module-card__status arx-corporate-module-card__status--${module.status}`}
              >
                {statusLabels[module.status]}
              </span>
            </div>

            <div className="arx-corporate-module-card__content">
              <h3>{module.name}</h3>
              <p>{module.description}</p>
            </div>

            <div className="arx-corporate-module-card__footer">
              <code>{module.route}</code>
              <span aria-label={`${module.name}: ${statusLabels[module.status]}`}>
                Acessar
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};
